import React, {Component} from 'react';
import {Col, Row} from "react-flexa";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from '@material-ui/core/TextField';
import SelectField from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import FilledInput from "@material-ui/core/FilledInput";
import InputLabel from '@material-ui/core/InputLabel';
import NumberFormat from 'react-number-format';
import Typography from '../../../../components/Typography';
import {emailRegex, getPenguinsData} from '../../../../helpers';
import get from "lodash/get";
import map from 'lodash/map';
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import find from "lodash/find";
import pickBy from 'lodash/pickBy';
import PropTypes from "prop-types";
import head from 'lodash/head';

class PhoneNumberInput extends React.PureComponent {
  render() {
    const {inputRef, onChange, className, value, name} = this.props;
    return (
      <NumberFormat
        required
        name={name}
        className={className}
        getInputRef={inputRef}
        value={value}
        onValueChange={values => {
          onChange({
            target: {
              value: values.value,
              name: 'phone',
              type: 'number',
            },
          });
        }}
        format="+1 (###) ###-####"
        mask="_"
        isNumericString
      />
    );
  };
}

class DetailsForm extends Component {
  constructor(props) {
    super(props);
    const {countries = [], lead_data = {}} = getPenguinsData('view_data');
    this.countryOptions = map(countries, value => ({label: value.name, value: value.id}));
    this.stateOptions = {};
    forEach(this.countryOptions, ({value: countryId}) => {
      this.stateOptions[countryId] = get(find(countries, ['id', countryId]), 'states', [])
        .map(option => ({label: option.name, value: option.id}));
    });
    let {first_name='', last_name='', email='', phone=''} = lead_data;
    const { country_id='1', initial_data={} } = getPenguinsData('view_data');
    let agreedToTerms = false;
    if (isEmpty(lead_data) && !isEmpty(initial_data)) {
      first_name = initial_data.first_name;
      last_name = initial_data.last_name;
      email = initial_data.email;
      phone = initial_data.phone;
      agreedToTerms = initial_data.agreed;
    }
    this.state = {
      didSubmit: false,
      addCoApplicant: false,
      agreedToTerms: agreedToTerms,
      formData: {
        country: country_id,
        state: initial_data.state || (country_id === '1' ? '15' : '60'),
        first_name,
        last_name,
        street1: initial_data.street1 || '',
        street2: initial_data.street2 || '',
        postal_code: initial_data.postal_code || '',
        city: initial_data.city || '',
        phone,
        email,
        coapplicant_first_name: '',
        coapplicant_last_name: '',
        coapplicant_email: ''
      },
      formErrors: {},
    };

    this.form = React.createRef();
    if (props.triggerSubmit) props.triggerSubmit(this.handleSubmit);
  }

  Input = ({classes = {}, InputLabelProps = {}, InputProps = {}, name, ...rest}) => {
    const className = classes.textField || get(this.props, ['classes', 'textField']);
    const {formErrors, didSubmit} = this.state;
    const hasError = !!formErrors[name] || !!this.props.addressErrors[name];
    const onBlur = () => {
      if (didSubmit) {
        const formErrors = this.validateFormData();
        this.setState({formErrors});
      }
    };
    return <TextField
      name={name}
      error={hasError}
      fullWidth
      variant="filled"
      margin="dense"
      align="left"
      onChange={this.handleFormChange}
      {...rest}
      InputLabelProps={{
        shrink: true,
        ...InputLabelProps,
      }}
      InputProps={{
        className,
        disableUnderline: !hasError,
        onBlur,
        ...InputProps
      }}
    />;
  };

  Select = ({options = [], classes = {}, ...props}) => {
    const className = classes.textField || get(this.props, ['classes', 'textField']);
    const {formErrors} = this.state;
    const hasError = !!formErrors[props.name] || !!this.props.addressErrors[props.name];
    return (
      <FormControl variant="filled" fullWidth margin="dense" error={hasError}>
        <InputLabel
          htmlFor={props.id}
          shrink
        >
          {props.label}
        </InputLabel>
        <SelectField
          autoWidth
          onChange={this.handleFormChange}
          {...props}
          native
          input={<FilledInput className={className} fullWidth name={props.name} id={props.id}
                              disableUnderline={!hasError}/>}
        >
          {
            map(options, option => <option key={option.value} value={option.value}>{option.label}</option>)
          }
        </SelectField>
      </FormControl>
    );
  };

  handleFormChange = event => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState(prevState => {
      const formData = {...prevState.formData};
      formData[name] = value;
      return {formData};
    });
  };

  handleStateChange = event => {
    const target = event.target;
    const value = target.type === 'checkbox'
      ? target.checked
      : String(target.value);
    const name = target.name;

    this.setState({
      [name]: value
    });
  };

  validateFormData = () => {
    const formErrors = {};
    const { formData, addCoApplicant, agreedToTerms } = this.state;
    const nameRegExp = /^[a-zA-Z][a-zA-Z '.-]{0,30}[a-zA-Z.]$/;
    const nameFields = ['first_name', 'last_name']
      .concat(addCoApplicant ? ['coapplicant_first_name', 'coapplicant_last_name'] : []);
    forEach(nameFields, field => {
      formErrors[field] = !nameRegExp.test(formData[field]);
    });

    const emailFields = ['email'].concat(addCoApplicant ? ['coapplicant_email'] : []);
    forEach(emailFields, field => {
      formErrors[field] = !emailRegex.test(formData[field]);
    });

    if (this.form && this.form.current && this.form.current.elements) {
      forEach(this.form.current.elements, (el) => {
        if (el.required && isEmpty(formData[el.name])) {
          formErrors[el.name] = true;
        }
      });
    }
    let errorFields = Object.keys(pickBy(formErrors));
    if (errorFields.length) {
      this.form.current.elements[head(errorFields)].focus();
    }

    if (!agreedToTerms) {
      formErrors.agreedToTerms = true;
    }

    return pickBy(formErrors);
  };

  handleSubmit = (e) => {
    if (e) e.preventDefault();
    const formErrors = this.validateFormData();
    this.setState({didSubmit: true, formErrors});
    const isValid = isEmpty(formErrors);
    if (this.props.onSubmit) this.props.onSubmit(isValid, this.state.formData);
  };

  render() {
    const {addCoApplicant, formData = {}, agreedToTerms} = this.state;
    const {country} = formData;
    const {Input, Select} = this;
    return (
      <div>
        <form ref={this.form} method="post" encType="multipart/form-data" onSubmit={this.handleSubmit}>
          <Row alignItems='center'>
            <Col xs={6}>
              <Input
                required
                value={formData.first_name}
                name='first_name'
                label="First Name"
                inputProps={{
                  minLength: 2,
                  maxLength: 50,
                  autoComplete: 'given-name',
                }}
              />
            </Col>
            <Col xs={6}>
              <Input
                required
                name='last_name'
                value={formData.last_name}
                label="Last Name"
                inputProps={{
                  minLength: 2,
                  maxLength: 50,
                  autoComplete: 'family-name',
                }}
              />
            </Col>
          </Row>
          <Row alignItems='center'>
            <Col xs={6}>
              <Input
                required
                name='email'
                value={formData.email}
                label="Email"
                inputProps={{
                  minLength: 8,
                  maxLength: 150,
                  type: 'email',
                  autoComplete: 'email',
                }}
              />
            </Col>
            <Col xs={6}>
              <Input
                required
                name='phone'
                value={formData.phone}
                label='Phone'
                inputProps={{
                  minLength: 7,
                  maxLength: 10,
                  autoComplete: 'tel',
                }}
                InputProps={{
                  inputComponent: PhoneNumberInput,
                }}
              />
            </Col>
          </Row>
          <Row alignItems='center'>
            <Col xs={12} md={6}>
              <Input
                required
                name='street1'
                value={formData.street1}
                label='Street Address'
                inputProps={{
                  minLength: 2,
                  maxLength: 30,
                  autoComplete: 'billing address-line1',
                }}
              />
            </Col>
            <Col xs={12} md={6}>
              <Input
                name='street2'
                value={formData.street2}
                label='Apt/Suite (optional)'
                inputProps={{
                  minLength: 2,
                  maxLength: 30,
                  autoComplete: 'billing address-line2',
                }}
              />
            </Col>
          </Row>
          <Row alignItems='center'>
            <Col xs={6}>
              <Input
                required
                name='city'
                value={formData.city}
                label='City'
                inputProps={{
                  minLength: 2,
                  maxLength: 30,
                  autoComplete: 'billing address-level2'
                }}
              />
            </Col>
            <Col xs={6}>
              <Select
                required
                name='state'
                value={formData.state}
                label={country === '2' ? 'Province' : 'State'}
                options={this.stateOptions[country || 1]}
                type='select'
                inputProps={{
                  minLength: 2,
                  maxLength: 30,
                  autoComplete: 'billing administrative-area address-level1'
                }}
              />
            </Col>
            <Col xs={6}>
              <Input
                required
                name='postal_code'
                value={formData.postal_code}
                label={`${country === '2' ? 'Postal' : 'Zip'} Code`}
                inputProps={{
                  minLength: 2,
                  maxLength: 30,
                  autoComplete: 'billing postal-code'
                }}
              />
            </Col>
            <Col xs={6}>
              <Select
                required
                name='country'
                value={formData.country}
                label='Country'
                type='select'
                options={this.countryOptions}
                inputProps={{
                  minLength: 2,
                  maxLength: 30,
                  autoComplete: 'billing country-name',
                }}
              />
            </Col>
          </Row>
          <FormControlLabel
            control={
              <Checkbox name='addCoApplicant' checked={addCoApplicant} onChange={this.handleStateChange}/>
            }
            label="Add Co-Applicant"
          />
          {addCoApplicant && (
            <Row>
              <Col xs={6}>
                <Input
                  required={addCoApplicant}
                  name='coapplicant_first_name'
                  value={formData.coapplicant_first_name}
                  label='Co-Applicant First Name'
                  inputProps={{
                    minLength: 2,
                    maxLength: 50,
                    required: true,
                  }}
                />
              </Col>
              <Col xs={6}>
                <Input
                  required={addCoApplicant}
                  name='coapplicant_last_name'
                  value={formData.coapplicant_last_name}
                  label='Co-Applicant Last Name'
                  inputProps={{
                    minLength: 2,
                    maxLength: 50,
                    autoComplete: 'family-name',
                    required: true,
                  }}
                />
              </Col>
              <Col xs={12}>
                <Input
                  required={addCoApplicant}
                  name='coapplicant_email'
                  value={formData.coapplicant_email}
                  label='Co-Applicant Email'
                  inputProps={{
                    minLength: 8,
                    maxLength: 150,
                    type: 'email',
                    autoComplete: 'email',
                    required: true,
                  }}
                />
              </Col>
            </Row>
          )}
          <hr/>
          <Row>
            <Col xs={12}>
              <FormControlLabel
                control={
                  <Checkbox name="agreedToTerms" checked={agreedToTerms} onChange={this.handleStateChange}/>
                }
                label={(
                  <Typography variant='subtitle2' style={{fontWeight: 400, lineHeight: '1.5', letterSpacing: 'normal'}}>
                    By checking this box, you agree to receive marketing messages from DirectBuy at the email address you provided.
                    You also authorize DirectBuy to call or text you at the number you provided for marketing purposes.
                    These calls / texts may be made using automated dialing or artificial voice technology.
                    Your consent to receive calls / texts is not a condition of making a purchase from us.
                    You may withdraw this consent at any time by emailing membercares@directbuy.com, calling 1-844-768-6945, or mailing 8450 Broadway, Merrillville, IN 46410
                  </Typography>
                )}
              />
              <div><a target="_blank" rel="noopener noreferrer"
                      href="https://www.directbuy.com/company/privacy-policy/">Privacy Policy</a></div>
            </Col>
          </Row>
        </form>
      </div>
    )
  }

}

DetailsForm.defaultProps = {
  addressErrors: {}
};

DetailsForm.propTypes = {
  classes: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
  triggerSubmit: PropTypes.func,
  addressErrors: PropTypes.object
};

export default DetailsForm;
